import { provideZonelessChangeDetection, ErrorHandler, inject, importProvidersFrom } from "@angular/core";
import { bootstrapApplication, BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy, provideRouter, withPreloading, PreloadAllModules } from '@angular/router';
import { IonicRouteStrategy, provideIonicAngular } from '@ionic/angular';
import { DatePipe, CurrencyPipe, registerLocaleData } from '@angular/common';
import { provideHttpClient } from '@angular/common/http';
import { provideTranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import localeNl from '@angular/common/locales/nl';
import localeEn from '@angular/common/locales/en';

import { AppComponent } from './app/app.component';
import { routes } from './app/app.routes';
import { provideFirebaseSDK } from './app/firebase-config';

import { GlobalService } from './app/services/global.service';
import { AuthenticationService } from './app/services/authentication.service';
import { UserService } from './app/services/user.service';
import { GlobalErrorHandler } from './app/services/global-error-handler.service';

// Initialize PWA elements for web platform
import { defineCustomElements } from '@ionic/pwa-elements/loader';

// Register all Ionicons globally
import { addIcons } from 'ionicons';
import {
  pin,
  person,
  time,
  hourglassOutline,
  logoEuro,
  alert,
  pricetag,
  hammerOutline,
  homeOutline,
  helpOutline,
  add,
  diamondOutline,
  helpCircleOutline,
  notificationsOutline,
  notificationsOffOutline,
  help,
  home,
  sadOutline,
  happyOutline,
  send,
  removeCircleOutline,
  addCircleOutline,
  basket,
  camera,
  thumbsDownOutline
} from 'ionicons/icons';

addIcons({
  pin,
  person,
  time,
  hourglassOutline,
  logoEuro,
  alert,
  pricetag,
  hammerOutline,
  homeOutline,
  helpOutline,
  add,
  diamondOutline,
  helpCircleOutline,
  notificationsOutline,
  notificationsOffOutline,
  help,
  home,
  sadOutline,
  happyOutline,
  send,
  removeCircleOutline,
  addCircleOutline,
  basket,
  camera,
  thumbsDownOutline
});

// Register locale data for date formatting
registerLocaleData(localeNl, 'nl');
registerLocaleData(localeEn, 'en');

bootstrapApplication(AppComponent, {
  providers: [
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    importProvidersFrom(BrowserModule),
    provideZonelessChangeDetection(),
    provideHttpClient(),
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    provideIonicAngular(),
    provideRouter(routes, withPreloading(PreloadAllModules)),
    provideTranslateService({
      fallbackLang: 'nl',
      loader: provideTranslateHttpLoader({
        resources: [
          { prefix: './assets/i18n/', suffix: '/public.json' },
          { prefix: './assets/i18n/', suffix: '/shared.json' },
          { prefix: './assets/i18n/', suffix: '/client.json' },
          { prefix: './assets/i18n/', suffix: '/worker.json' }
        ],
        useHttpBackend: true,
        failOnError: true
      })
    }),
    ...provideFirebaseSDK(),
    DatePipe,
    CurrencyPipe,
    GlobalService,
    AuthenticationService,
    UserService,
  ]
}).catch(err => console.log(err));

// Initialize PWA elements for camera and other web components
defineCustomElements(window);
